import { DialogStateSetterContext } from "../../contexts/dialog-context-provider";
import { useContextSafely } from "../../utils/react-utils";

export function useDialog(suppressErrorMessage?: boolean) {
  return useContextSafely(DialogStateSetterContext, suppressErrorMessage, useDialog.name);
}
